import {
    AssetManager,
    Dropdown,
    GenericWrapperContext,
    Icon,
    Typography,
    EAssetManagerMatchType,
    TAssetManagerOption
} from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import { TTagEdit, TTagEditCat } from "./types"
import { ETemplatesFilters, templateTagsFilterOptions } from "../../../../data/tags"
import { getLanguagesOptions } from "../../../../data/language"
import { useContext, useState } from "react"
import Box from "@mui/material/Box"
import { SelectChangeEvent } from "@mui/material/Select"
import { ClickAwayListener } from "@mui/material"
import { TButtonRef } from "@cakemail-org/ui-components-v2/dist/esm/components/button/types"

export function InlineTagEdit({ category, value = "", values = [], onChange, extraFilterOptions }: TTagEdit) {
    const genericWrapperContext = useContext(GenericWrapperContext)
    const { t } = useTranslation()
    const [showActionBar, setShowActionBar] = useState<boolean>(false)

    function handleOnDDChange(event: SelectChangeEvent<string>, node: any, prevValue?: string) {
        const { name, value } = event.target
        onChange({ name: name as TTagEditCat, value, prevValue })
    }

    function handlePrimaryAction(event: React.MouseEvent<HTMLButtonElement>, btnRef: TButtonRef, option: TAssetManagerOption) {
        onChange({ name: category, option, value: "tag" }, btnRef)
    }
    function handleSecondaryAction(event: React.MouseEvent<HTMLButtonElement>, btnRef: TButtonRef, option: TAssetManagerOption) {
        onChange({ name: category, option, value: "untag" }, btnRef)
    }

    function handleActionBar() {
        if (!["type", "language"].includes(category))
            setShowActionBar(true)
    }

    let content: any = ""
    if (category === "type") {
        content = <Dropdown
            menuPlacement="bottom-left"
            name={category}
            onChange={handleOnDDChange}
            variant="standard"
            value={value}
            options={templateTagsFilterOptions()[ETemplatesFilters.plan]}
            placeholder={t("general-plan-select-placeholder ")}
        />
    } else if (category === "language") {
        const languageList = getLanguagesOptions({ partnerBrand: genericWrapperContext?.partnerBrand, prefixToAdd: "sys_lang_", toLowerCase: true })
        languageList.unshift({ text: t("general-all"), value: "all" })
        content = <Dropdown
            menuPlacement="bottom-left"
            name={category}
            onChange={handleOnDDChange}
            variant="standard"
            value={value}
            options={languageList}
            placeholder={t("general-language-select-placeholder")}
        />
    } else {
        const currentFilterCat = templateTagsFilterOptions(extraFilterOptions)[category]

        content = <Box className="assetManagerEdit" onClick={handleActionBar}>
            {values?.map((v) => {
                const currentV = v.replace(category + "_", "")
                const curFilter = currentFilterCat.find((filter) => {
                    return filter.value === currentV
                })
                return curFilter?.text || currentV
            }).join(", ")}
            {values?.length === 0 ?
                <Typography variant="linkL">{t("general-add-tag")}</Typography>
                :
                <Icon name="Edit18" color="secondary" />
            }

        </Box>
    }

    const options: TAssetManagerOption[] = templateTagsFilterOptions(extraFilterOptions)[category]?.map((tagFilter) => {
        const value = category + "_" + tagFilter.value
        return {
            text: tagFilter.text,
            value: value,
            matchType: values?.includes(value) ? EAssetManagerMatchType.full : undefined,
        }
    }) || []

    return <>
        <Box className="inlineTagEdit" onClick={handleActionBar}>
            {content}
        </Box>
        {showActionBar &&
            <ClickAwayListener onClickAway={() => { setShowActionBar(false) }}>
                <Box className="inlineTagEditFixedBar" >
                    <AssetManager
                        options={options}
                        listMainBtn={{
                            text: t("general-tag_one"),
                            onClick: handlePrimaryAction
                        }}
                        listSecondaryBtn={{
                            text: t("general-untag"),
                            onClick: handleSecondaryAction
                        }}
                        manageBtn={{
                            text: t("general-close"),
                            onClick: () => {
                                setShowActionBar(false)
                            }
                        }}
                    />
                </Box>
            </ClickAwayListener>
        }

    </>
}